module.exports = __webpack_public_path__ + "img/w1.faf44d95.png";